import { ChangeDetectorRef, Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AddBankInAccountComponent } from 'src/app/AddThings/add-bank-in-account/add-bank-in-account.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { AccountService } from 'src/services/companyAcccount.service';
import { BankInDetails, AppliedBranchDetails } from '../apply-asset-request/apply-asset-request.component';
import { GlobalSearchCustomerComponent } from 'src/app/Others/global-search-customer/global-search-customer.component';
import { GlobalCustomer } from 'src/model/globalCustomer.model';
import { ManageApprovedBankInAccountComponent } from '../manage-approved-bank-in-account/manage-approved-bank-in-account.component';
import { SelectApprovedTicketComponent } from '../select-approved-ticket/select-approved-ticket.component';
import { LoanRequest } from 'src/model/loanRequest.model';
import { Customer } from 'src/model/customer.model';
import { AssetRequestSummaryComponent } from '../asset-request-summary/asset-request-summary.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormJService } from 'src/services/form-j.service';
import { BusinessService } from 'src/services/business.service';
import { LoanGroupService } from 'src/services/loan-group.service';
import { CompanyService } from 'src/services/company.service';
import { FinanceAccount } from 'src/model/financeAccount.model';

@Component({
	selector: 'app-asset-apply-details',
	standalone: false,
	templateUrl: './asset-apply-details.component.html',
	styleUrl: './asset-apply-details.component.scss'
})
export class AssetApplyDetailsComponent implements OnInit, OnChanges {
	@Input() selectedApplyOpt: string;

	@Input() protected companyId: number;
	@Input() protected companyCode: string;
	@Input() protected defaultFinanceAccount: FinanceAccount;
	protected disabledSubmit = false;

	protected sharedService = inject(SharedService);
	protected restApi = inject(RestApiService);
	protected constructApi = inject(ConstructAPI);
	protected companyAccountService = inject(AccountService);
	protected enums = inject(Enums);
	protected cdr = inject(ChangeDetectorRef);
	protected activeModal = inject(NgbActiveModal);
	protected formJService = inject(FormJService);
	protected businessService = inject(BusinessService);
	protected loanGroupService = inject(LoanGroupService);
	protected companyService = inject(CompanyService);

	protected reason: string;
	protected isShared: boolean = false;
	protected totalAmount: number = 0;
	protected totalBankAmount: number = 0;
	protected totalBranchAmount: number = 0;
	protected finalDistribution: any[] = new Array();
	protected kerjaContraList: AppliedBranchDetails[] = new Array();

	protected cashInOffice: number;
	protected lastCheckedInDate: Date;
	protected bankInDetailsList: BankInDetails[] = [];
	protected appliedBranchList: AppliedBranchDetails[] = [];

	protected selectedCustomer: GlobalCustomer;
	protected loanRequestList: LoanRequest[] = new Array();
	protected groupedLoanRequestList = new Array();

	protected includeKerja = false;
	protected uuid: string;

	protected constructedMessage: string;

	protected totalTicketAmount: number = 0;
	protected isDistributionCollapse = true;
	protected formJCompany: string = '';

	// need to list down branch distribution first only list bank in amount, so that can do distribution calculation by system!!!

	async ngOnInit(): Promise<void> {}

	async ngOnChanges(changes: SimpleChanges) {
		if (changes.selectedApplyOpt) {
			this.resetEverything();
		}

		if (this.selectedApplyOpt == 'EXPENSES') {
			this.lastCheckedInDate = await this.getCompanyLatestCheckIn(this.companyId);

			var accounts = await this.companyAccountService.getAllAccountsOfCompany(this.companyId);
			this.cashInOffice = accounts.reduce((sum, acc) => sum + acc.Balance, 0);
		}
	}

	getCompanyLatestCheckIn(companyId: number) {
		return new Promise<Date>(resolve => {
			const xhttp = this.restApi.getRequest(this.constructApi.getCompaniesLatestCheckIns(companyId));
			xhttp.onreadystatechange = () => {
				if (xhttp.readyState == 4 && xhttp.status == 200) {
					const jsonArray = JSON.parse(xhttp.responseText);
					jsonArray.forEach((json: any) => {
						resolve(new Date(json.date));
					});
				}
			};
		});
	}

	openAddBankInAccountModal() {
		const modalRef = this.sharedService.openModal(AddBankInAccountComponent);

		modalRef.componentInstance.addedBank.subscribe((entry: CustomerAccount) => {
			const account = entry;
			this.bankInDetailsList.push({ bankInAccount: account, amount: 0 });
		});
	}

	getSelectedCompany(company: Company) {
		if (this.appliedBranchList.find(item => item.appliedBranch.ID == company.ID)) {
			this.sharedService.openAlert('This branch existed in list, please check properly!', ALERT_TYPE.DANGER);
		} else {
			this.appliedBranchList.push({ appliedBranch: company, amount: 0 });
			this.cdr.detectChanges();
		}
	}

	removeBranch(index: number) {
		this.appliedBranchList.splice(index, 1);
		this.onAmountChange();
	}

	removeBank(index: number) {
		this.bankInDetailsList.splice(index, 1);
		this.onAmountChange();
	}

	getTotal(list: any[], key: string): number {
		return list.reduce((sum, acc) => {
			return sum + (acc[key] ?? 0);
		}, 0);
	}

	onAmountChange() {
		this.totalBankAmount = this.getTotal(this.bankInDetailsList, 'amount');
		this.totalBranchAmount = this.getTotal(this.appliedBranchList, 'amount');
		const totalKerja = this.getTotal(this.appliedBranchList, 'kerja');
		this.totalBranchAmount -= totalKerja;

		// if (this.totalBankAmount == this.totalAmount && this.totalBranchAmount == this.totalAmount)
		//   this.processContraAndDistribute();
	}

	searchCustomerAndLoadDetails() {
		const modalRef = this.sharedService.openModal(GlobalSearchCustomerComponent, 'largeModal');
		modalRef.componentInstance.isGlobal = false;
		modalRef.componentInstance.needRedirect = false;

		modalRef.componentInstance.passEntry.subscribe(async (entry: any) => {
			this.selectedCustomer = entry;
			this.reason = 'KERJA - ' + this.selectedCustomer.Name + '(' + this.selectedCustomer.ICNumber + ')';
		});
	}

	selectTicket(withLoan: boolean) {
		const modalRef = this.sharedService.openModal(SelectApprovedTicketComponent, 'largeModal');
		modalRef.componentInstance.withLoan = withLoan;
		modalRef.componentInstance.addedLgIds = this.loanRequestList.map(t => t.LoanGroupId);
		modalRef.componentInstance.inUseFormJCompany = this.formJCompany;

		modalRef.componentInstance.customerId = this.selectedCustomer?.CustomerID;
		modalRef.componentInstance.passEntry.subscribe(
			async ({ entry, formJCompany, defaultFinanceAccount }: { entry: LoanRequest[]; formJCompany: string; defaultFinanceAccount: FinanceAccount }) => {
				this.formJCompany = formJCompany;
				this.defaultFinanceAccount = defaultFinanceAccount;
				this.loanRequestList.push(...entry);
				this.processTickets();

				var loggedInUserRequest = this.loanRequestList.find(r => r.CompanyId == this.companyId);

				this.selectedCustomer = new GlobalCustomer(
					loggedInUserRequest?.CustomerName,
					loggedInUserRequest?.CustomerIC,
					loggedInUserRequest?.CompanyCode,
					loggedInUserRequest?.CustomerId
				);

				if (entry.length > 0) {
					entry.forEach(e => {
						var index = this.appliedBranchList.findIndex(b => b.appliedBranch.CompanyCode == e.CompanyCode);
						if (index == -1)
							this.appliedBranchList.push({
								appliedBranch: new Company(e.CompanyId, undefined, undefined, e.CompanyCode),
								amount: this.sharedService.calculateTotalOnHand(e.LoanInfo)
							});
						else {
							this.appliedBranchList[index].amount += this.sharedService.calculateTotalOnHand(e.LoanInfo);
						}
						this.cdr.detectChanges();
					});
				}
				this.onAmountChange();
			}
		);
	}

	resetEverything() {
		this.bankInDetailsList = [];
		this.clearTickets();
		this.totalAmount = 0;
		this.reason = '';
		this.includeKerja = false;
		this.isShared = false;
	}

	clearTickets() {
		this.loanRequestList = [];
		this.groupedLoanRequestList = [];
		this.appliedBranchList = [];
		this.finalDistribution = [];
		this.kerjaContraList = [];
		this.selectedCustomer = undefined;
		this.totalTicketAmount = 0;
		this.onAmountChange();
		this.cdr.detectChanges();
	}

	async processTickets() {
		this.totalTicketAmount = 0;
		const grouped = this.loanRequestList.reduce(
			(acc, ticket) => {
				const key = ticket.LoanGroupId;

				//group same loan group tickets
				if (!acc[key]) {
					acc[key] = [];
				}

				acc[key].push(ticket); //  push full object

				return acc;
			},
			{} as Record<string, LoanRequest[]>
		);

		const group = Object.keys(grouped).map(lgId => ({
			lgId,
			request: grouped[lgId]
		}));

		this.groupedLoanRequestList = await Promise.all(
			group.map(async group => {
				//start group and calculate
				const groupedOnHand = group.request.reduce((sum, request) => sum + this.sharedService.calculateTotalOnHand(request.LoanInfo), 0);

				const ids = group.request.map(r => `#${r.ID}`).join(',');
				const customerInfo = `${group.request[0].CustomerName} (${group.request[0].CustomerIC})`;
				this.totalTicketAmount += groupedOnHand;

				return {
					...group,
					totalOnHand: groupedOnHand,
					customerInfo: customerInfo,
					ids: ids,
					formJCompany: this.formJCompany,
					defaultFinanceAccount: this.defaultFinanceAccount
				};
			})
		);
	}

	openSelectCustomerAccounts() {
		const modalRef = this.sharedService.openModal(ManageApprovedBankInAccountComponent, 'largeModal');
		modalRef.componentInstance.selectedCustomer = this.selectedCustomer;

		modalRef.componentInstance.addedBank.subscribe(async (entry: CustomerAccount) => {
			this.bankInDetailsList.push({ bankInAccount: entry, amount: 0 });
		});
	}

	sharedEvenly() {
		this.appliedBranchList.forEach(item => {
			item.amount = this.totalAmount / this.appliedBranchList.length;
		});
		this.onAmountChange();
	}

	addLoggedInCompanyIntoList() {
		this.appliedBranchList = [];

		if (this.isShared) {
			this.appliedBranchList.push({
				appliedBranch: new Company(this.companyId, undefined, undefined, this.companyCode),
				amount: 0
			});
		} else
			this.appliedBranchList.push({
				appliedBranch: new Company(this.companyId, undefined, undefined, this.companyCode),
				amount: this.totalAmount
			});
	}

	checkError() {
		let error: string[] = new Array();

		if (this.totalAmount == 0 || this.totalAmount == undefined) error.push('- Applied Amount');

		if (this.reason == '' || this.reason == undefined) error.push('- Reason');

		if (this.sharedService.roundTo2Dec(this.totalAmount) != this.sharedService.roundTo2Dec(this.totalBankAmount))
			error.push(`- Bank amount (RM ${this.totalBankAmount}) not tally with applied amount (RM ${this.totalAmount})!`);

		if (this.isShared && this.sharedService.roundTo2Dec(this.totalAmount) != this.sharedService.roundTo2Dec(this.totalBranchAmount))
			error.push(`- Shared with branch amount (RM ${this.totalBranchAmount}) not tally with applied amount (RM ${this.totalAmount})!`);

		// const totalAfterDeductingKerja =
		if (this.selectedApplyOpt == 'TICKET') {
			if (this.groupedLoanRequestList.length == 0) error.push('- Please select ticket!');
			else if (this.totalTicketAmount != this.totalAmount) {
				if (this.includeKerja == false) error.push(`- Ticket Amount (RM ${this.totalTicketAmount} is not equal to applied amount (RM ${this.totalAmount})`);
				else if (this.totalAmount != this.totalBranchAmount) {
					error.push(`- Shared with branch amount (RM ${this.totalBranchAmount}) not tally with applied amount (RM ${this.totalAmount})!`);
				}
			}
		}

		return error;
	}

	submit() {
		this.disabledSubmit = true;

		let error = this.checkError();
		if (error.length == 0) {
			const modalRef = this.sharedService.openModal(AssetRequestSummaryComponent, 'largeModal');

			modalRef.componentInstance.bankInDetailsList = this.bankInDetailsList;
			modalRef.componentInstance.appliedBranchList = this.appliedBranchList;
			modalRef.componentInstance.includeKerja = this.includeKerja;
			modalRef.componentInstance.selectedCustomer = this.selectedCustomer;
			modalRef.componentInstance.ticketList = this.groupedLoanRequestList;
			modalRef.componentInstance.type = this.selectedApplyOpt;
			modalRef.componentInstance.amount = this.totalAmount;
			modalRef.componentInstance.reason = this.reason;
			modalRef.componentInstance.selectedApplyOpt = this.selectedApplyOpt;
			modalRef.componentInstance.formJCompany = this.formJCompany;
			modalRef.componentInstance.cashInOffice = this.cashInOffice;
			modalRef.componentInstance.lastestCheckIn = this.lastCheckedInDate;

			console.log(this.lastCheckedInDate);
			modalRef.componentInstance.selectedCustomer = this.selectedCustomer;
			modalRef.componentInstance.defaultFinanceAccount = this.defaultFinanceAccount;

			modalRef.componentInstance.loggedInCompany = new Company(this.companyId, undefined, undefined, this.companyCode);
			this.activeModal.close();
		} else {
			this.sharedService.openAlert('Please fix following problem:\n' + error.join('\n'), ALERT_TYPE.DANGER);
			this.disabledSubmit = false;
		}
	}
}
